import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonnePhysiqueList extends ShadowDOMElement {
	static className = "PersonnePhysiqueList";
	
	static properties = {
		labelAddButton: { type: String, attribute: "label-add-button"},
		title: {type: String, attribute: "title"}
	};

	constructor() {
		super();
		this.managers = [];
		this.labelAddButton = "Ajouter une personne physique";
		this.title = "";
	}

	firstUpdated() {
		super.firstUpdated();
		this.addManager();
	}

	addManager() {
		const managerContainer = document.createElement("personne-physique");

		if (this.managers.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(managerContainer);
			this.appendChild (deleteButtonWrapper);
		}

		this.managers.push (managerContainer);
		this.appendChild (managerContainer);
	}

	removeManager (managerContainer, deleteButtonWrapper) {
		this.managers = this.managers.filter ((manager) => manager !== managerContainer);
		this.removeChild (managerContainer);
		if (deleteButtonWrapper)
			this.removeChild (deleteButtonWrapper);
	}

	createDeleteButton (managerContainer) {
		const deleteButtonWrapper = document.createElement ("row-wrapper");
		const deleteButton = document.createElement ("button-field");

		deleteButton.onClickHandler = () => {
			this.removeManager (managerContainer, deleteButtonWrapper);
		};

		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;
		deleteButtonWrapper.appendChild (deleteButton);

		return deleteButtonWrapper;
	}

	render (){
		return html`
			${this.title ? html`
			<row-wrapper>
				<subtitle-field label="${this.title}"></subtitle-field>
			</row-wrapper>
			` : ""}
			<slot></slot>
			<row-wrapper data-add-button="true">
				<button-field .onClickHandler="${this.addManager.bind(this)}">
					<i class="fa fa-plus"></i><span>&nbsp;${this.labelAddButton}</span>
				</button-field>
			</row-wrapper>
	    `;
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {
			"count" : this.managers.length || 1,
			... super.getValues ()
		}
	}
	
	setValues (values){
		while (this.managers.length < values.count)
	        this.addManager ();
		super.setValues (values);
	}
}

customElements.define ("personne-physique-list", PersonnePhysiqueList);
